import React from "react";
import { useAuthContext } from "../../providers/Auth/auth.provider";
import config from "../../config/config";
import { getPomAdminNavItems } from "../../pom-navigation-items";
import { isAdmin } from "../user/user";
import { SidebarMenuItem } from "./sidebar-menu-item.component";

export const SidebarAdminMenu: React.VFC = () => {
  const { internalUser } = useAuthContext();
  const adminNavItems = getPomAdminNavItems(config.bcEditMasterDataUrl);

  if (!isAdmin(internalUser)) return null;

  return (
    <>
      {adminNavItems
        .filter((item) => item.visible && item.content)
        .map((item, index) => {
          return (
            <SidebarMenuItem key={`admin-${item.to}-${index}`} name="admin" navItem={item} menuItem={item.label} />
          );
        })}
    </>
  );
};
